<template>
  <div class="body-t">
    <van-notice-bar
        background="#ffffff"
        color="#404040"
        left-icon="volume-o"
        mode="closeable"
        text="根据您企业关联的行业或品类精准推送相关内容的招标，点击即可查看或报名"
    />

    <div class="user-box">

      <div class="main-top van-clearfix">
        <div>
          <van-image :src="this.$store.state.auth.company.logo"
                     class="company-logo"
                     fit="contain" lazy-load
          >
            <template v-slot:error>无企业LOGO</template>
          </van-image>
        </div>
        <div>
          <div class="company-title">
            {{ this.$store.state.auth.company.CompanyName ? this.$store.state.auth.company.CompanyName : "-" }}
          </div>
          <div class="cr-code">
            统一信用代码：{{ this.$store.state.auth.company.CreditCode ? this.$store.state.auth.company.CreditCode : '-' }}
          </div>
        </div>
      </div>
      <div class="category-box">
        <div style="margin-bottom: 8px;color:rgba(194, 150, 94, .5)">
          已选择行业：
        </div>
        <span v-for="item in category" :key="item.IndustryId">{{ item.IndustryName }}</span>
      </div>
      <div style="text-align: center;color: #FFFFFF;margin-bottom: -18px;font-size: 18px;color: rgba(197, 150, 33,.4 )">
        <van-icon name="arrow-down"/>
      </div>
    </div>

    <div class="count-bar">
      共查询到<span class="total">{{ this.total }}</span>条招标信息
      <span style="float: right">
        <span style="color: #909399">仅显示未截止招标 </span>
        <van-switch v-model="is_online" size="12" style="vertical-align: top" @change="init(true)"/>
      </span>
    </div>

    <ul class="data-list">
      <van-list
          v-model="load"
          :finished="finished"
          finished-text="已经到底了~"
          @load="init"
      >
        <li v-for="item in list" :key="item.BidId">
          <a :href="item.reg_link.h5" target="_blank">
            <div class="data-box van-clearfix">


              <div>
                <van-image :src="item.logo" class="company-logo" fit="contain" lazy-load
                >
                  <template v-slot:error>无企业LOGO</template>
                </van-image>
              </div>
              <div>
                <div class="bid-title van-multi-ellipsis--l2">
                  {{ item.BidTitle }}
                </div>
                <div class="city-category-box">
                  <span><van-icon name="location-o"/>{{ item.CName }}</span>
                </div>
              </div>
            </div>
            <div class="bid-desc">
              <dl>
                <dd><span class="synopsis"><van-icon name="label-o"/>招标品类：</span>{{ item.IndustryName }}</dd>
                <dd><span class="synopsis"><van-icon name="todo-list-o"/>招标周期：</span>{{ item.count.timer }}天</dd>
                <dd><span class="synopsis"><van-icon name="certificate"/>报名截止：</span>{{ item.bid_end_time }}</dd>
                <dd><span class="synopsis"><van-icon name="clock-o"/>发布时间：</span>{{ item.create_time }}</dd>

              </dl>
              <div class="progress-box">
                <van-circle
                    v-model="item.count.progress"
                    :color="gradientColor"
                    :rate="item.count.progress"
                    :size="55"
                    :text="item.count.surplus_day<=0?'已截止':item.count.surplus_day+'天'"
                    layer-color="#eff3f6"
                    stroke-width="100"
                />
              </div>
            </div>
          </a>
        </li>
      </van-list>
    </ul>

  </div>
</template>
<style scoped>
.pd-10 {
  padding: 10px;
}


.body-t {
  background: #eff3f6;
  padding-bottom: 60px;
  min-height: calc(100vh);
}

.data-box > div {
  float: left;
  box-sizing: border-box;
}

.data-box > div:nth-child(1) {
  width: 100px;
}

.data-box > div:nth-child(2) {
  width: calc(100% - 100px - 10px);
  margin-left: 10px;
}

.company-logo {
  width: 100px;
  height: 65px;
  display: block;
  background: white;
  object-fit: contain;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 0 3px;
  border: 1px solid #f2f2f2;
}

.data-list {
  padding: 10px;
}

.data-list li {
  margin-bottom: 10px;
  background: #FFFFFF;
  padding: 10px;
  border-radius: 2px;
}

.user-box {
  min-height: 170px;
  background: linear-gradient(
      296deg, #2E2A29 0%, #404040 100%);
  padding: 25px 10px;
  box-sizing: border-box;
  box-shadow: 0px 2px 25px -5px #646566;
  position: relative;
}

.user-box::before {
  content: " ";
  background: url("~@/assets/images/bg_rank.png") no-repeat;
  background-size: contain;
  height: 120px;
  width: 75px;
  position: absolute;
  top: 0;
  right: 0;
}

.user-box .company-logo {
  width: 120px;
  border: none;
}

.main-top {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(194, 150, 94, .2)
}

.main-top > div {
  float: left;
  box-sizing: border-box;
}

.main-top > div:nth-child(1) {
  width: 120px;
  margin-right: 10px;
}

.main-top > div:nth-child(2) {
  width: calc(100% - 130px);
  display: grid;
  height: 65px;
  align-items: center;
}

.company-title {
  color: #E8B279;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
}

.cr-code {
  font-size: 12px;
  color: rgba(232, 191, 162, .6);
}

.category-box {
  font-size: 12px;
  color: rgba(218, 165, 32, .78);
  margin-top: 10px;
}

.category-box > span {
  padding: 2px 8px;
  border-radius: 2px;
  display: inline-block;
  margin-right: 5px;
  border: 1px solid;
  margin-bottom: 8px;
}

.category-box > span:last-child {
  margin-right: 0;
}

.bid-title {
  font-size: 14px;
  letter-spacing: 1px;
  line-height: 1.25rem;
  color: #404040;
  height: 40px;
}

.city-category-box {
  color: #F62A3A;
  font-size: 12px;
  margin-top: 5px;
}

.bid-desc {
  border-top: 1px solid #f2f2f2;
  margin-top: 10px;
  padding: 10px 0;
  font-size: 12px;
  position: relative;
}

.bid-desc > dl {
  margin: 0;
}

.bid-desc dd {
  margin-left: 0;
  margin-bottom: 8px;
  letter-spacing: 1px;
  color: #646566;
}

.synopsis {
  color: #909399;
  letter-spacing: .5px;
}

.progress-box {
  position: absolute;
  top: 10px;
  right: 0;

}

.data-list a {
  display: block;
}

.progress-box /deep/ .van-circle__text {
  font-size: 12px;
  color: #404040;
}

.count-bar {
  margin-top: 10px;
  font-size: 12px;
  padding: 0 10px;
  letter-spacing: .2px;
}

.count-bar .total {
  color: #F62A3A;
  letter-spacing: 0;
  margin: auto 2px;
}
</style>
<script>

export default {
  name: "Bid",
  metaInfo() {
    return {
      title: '与我相关的行业招标信息-优采云大数据服务平台',
      htmlAttrs: {
        lang: 'zh-CN',
        keyword: '优采云，大数据，云服务，报告',
        amp: true
      }
    }

  },
  data() {
    return {
      gradientColor: {
        '0%': '#3fecff',
        '100%': '#6149f6',
      },
      load: false,
      popup: {
        open: false
      },
      list: [],
      category: [],
      total: 0,
      is_online: false,
      finished: false,
      page: 1
    }
  },
  mounted() {
  },
  methods: {
    init(reset_page = false) {
      //某些情况下重置
      if (reset_page) {
        this.page = 1
        this.list = []
        this.finished = false
      }
      this.load = true
      this.$axios.post(this.$apiconfg.bid_author, {
        page: this.page,
        is_online: this.is_online,
      }).then(({data}) => {
        if (data.code === 1) {
          //翻页
          this.page += 1
          //没有下一页了
          if (data.data.hasMore) {
            this.finished = false
          } else {
            this.finished = true
          }
          for (let i = 0; i < data.data.list.length; i++) {
            this.list.push(data.data.list[i])
          }

          this.total = data.data.total
          this.category = data.data.category
        }
        this.load = false
      }).catch(() => {
        this.load = false
        this.finished = true
      })
    }
  }
}
</script>

